import React from 'react';
import { Helmet } from 'react-helmet';

interface MetaTagProps {
    title: string;
    description: string;
    image?: any;
}

const MetaTag = (props: MetaTagProps) => {
    const { title, description, image } = props;
    const metaTitle = title || 'Infinite Launch - Where ideas become realities';
    const metaDescription = description || 'Cross-chain launchpad for disruptive Gamefi & NFT projects';
    const metaImage = image || 'thumbnail.jpg';
    return (
        <div>
            <Helmet>
                <title>{metaTitle}</title>
                <meta property="og:title" content={metaTitle} />
                <meta property="og:description" content={metaDescription} />
                <meta property="og:image" content={metaImage} />
            </Helmet>
        </div>
    );
};

export default MetaTag;
